import routes from './routes'
import { clientRender, setupReducers } from '@dnamicro/controls/lib/node/dna-router'
import createSagaMiddleware from 'redux-saga'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
// Change session value to approriate project

const sagaMiddleware = createSagaMiddleware()
// initialize primus

clientRender(
  routes,
  setupReducers(reducers),
  () => {
    sagaMiddleware.run(sagas)
  },
  sagaMiddleware
)

if (module.hot) {
  module.hot.accept(['./routes', './redux/reducers', './redux/actions', './redux/sagas'], () => {
    clientRender(
      routes,
      setupReducers(reducers),
      () => {
        sagaMiddleware.run(sagas)
      },
      sagaMiddleware
    )
  })
}



// WEBPACK FOOTER //
// ./src/main.js